import { createTheme } from "@mui/material";
import palette from "./components/palette";
import typography from "./components/typography";
import button from "./components/button";
import chip from "./components/chip";
import tab from "./components/tab";
import { card, cardHeader } from "./components/card";

const DefaultTheme = createTheme({
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 900,
      lg: 1200,
      xl: 1536,
    },
  },
  palette: palette.light,
  typography,
  components: {
    MuiButton: button,
    MuiLoadingButton: button,
    MuiChip: chip,
    MuiTab: tab,
    MuiCard: card,
    MuiCardHeader: cardHeader,
  },
});

export default DefaultTheme;
